/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const rejectDataSchema = z.object({ rejected: z.literal(true) });

export const rejectCollectionTriageClipResponseSchema = createApiResponseSchema(
  rejectDataSchema,
) as z.ZodSchema<IAPI<{ rejected: true }>>;

export type IRejectCollectionTriageClipResponse = IAPI<{ rejected: true }>;
